module.exports = __webpack_public_path__ + "img/sosTitBg1.ccd114de.png";